import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { AnalyticsServiceService } from "src/app/services/analitycsService/analytics-service.service";
import { Store } from "@ngrx/store";
import { first } from "rxjs/operators";
import * as fromApp from "../../../store/app.reducer";

@Component({
  selector: "app-billing-info-verify",
  templateUrl: "./billing-info-verify.component.html",
  styleUrls: ["./billing-info-verify.component.scss"],
})
export class BillingInfoVerifyComponent implements OnInit {
  @Input() verifyAddressRes: any;
  public hideMobile = false;
  constructor(
    private modalController: ModalController,
    private analyticsService: AnalyticsServiceService,
    private store: Store<fromApp.AppState>
  ) {}

  ngOnInit() {
    console.log("billing info verify res", this.verifyAddressRes);
    this.store
      .select("auth")
      .pipe(first())
      .subscribe((authState) => {
        this.hideMobile = !!(
          authState?.user?.only_dinein || authState?.user?.only_visitor
        );
      });
  }

  closeModal() {
    this.modalController.dismiss();
  }

  onClick(action) {
    if (action === "fix") {
      this.analyticsService.dmAnalyticsMessage(
        "billing_info_address_fixed_button_pressed",
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      );
    }
    this.modalController.dismiss(action);
  }
}
